
export default function WhyAluminum() {
  const benefits = [
    {
      icon: 'ri-recycle-line',
      title: '100% 재활용 가능',
      subtitle: '100% Recyclable',
      description: '알루미늄은 품질 저하 없이 무한 재활용이 가능합니다'
    },
    {
      icon: 'ri-leaf-line',
      title: '환경 영향 10배 감소',
      subtitle: '10x Less Environmental Impact',
      description: '플라스틱 대비 환경에 미치는 영향이 현저히 낮습니다'
    },
    {
      icon: 'ri-drop-line',
      title: '미세플라스틱 ZERO',
      subtitle: 'Zero Microplastics',
      description: '물에 미세플라스틱이 전혀 섞이지 않습니다'
    },
    {
      icon: 'ri-shield-check-line',
      title: '완벽한 보존력',
      subtitle: 'Perfect Preservation',
      description: '빛과 산소로부터 물을 완벽하게 보호합니다'
    },
    {
      icon: 'ri-plant-line',
      title: '지속 가능한 선택',
      subtitle: 'Sustainable Lifestyle',
      description: '미래 세대를 위한 책임 있는 소비입니다'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center space-y-4 mb-20">
          <h2 className="text-5xl lg:text-6xl font-light text-gray-900 tracking-tight">
            Why Aluminum?
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto"></div>
          <p className="text-xl text-gray-600 font-light mt-6">
            알루미늄을 선택하는 이유
          </p>
        </div>

        {/* Main Feature Card */}
        <div className="mb-16 bg-gradient-to-br from-blue-600 to-blue-400 rounded-3xl p-12 lg:p-16 text-white shadow-2xl">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full backdrop-blur-sm">
                <i className="ri-recycle-line text-4xl text-white"></i>
              </div>
              <h3 className="text-4xl lg:text-5xl font-light">
                Infinitely Recyclable
              </h3>
              <p className="text-xl font-light text-blue-50 leading-relaxed">
                알루미늄은 재활용될 때마다 품질이 유지되며, 
                영구적으로 재사용할 수 있는 유일한 소재입니다.
                지구를 위한 가장 현명한 선택입니다.
              </p>
            </div>
            <div className="relative h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/3f9712096bb066fbcf3a84c01be3536b.jpg"
                alt="Aluminum Recycling"
                className="w-full h-full object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-50 to-gray-50 rounded-full mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${benefit.icon} text-3xl text-blue-600`}></i>
              </div>
              <h4 className="text-2xl font-medium text-gray-900 mb-2">
                {benefit.title}
              </h4>
              <p className="text-sm text-blue-600 font-medium mb-4">
                {benefit.subtitle}
              </p>
              <p className="text-gray-600 font-light leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}

          {/* CTA Card */}
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 shadow-lg flex flex-col justify-center items-center text-center space-y-6 md:col-span-2 lg:col-span-1">
            <i className="ri-earth-line text-6xl text-blue-400"></i>
            <h4 className="text-2xl font-light text-white">
              지구를 위한<br />현명한 선택
            </h4>
            <button className="bg-white text-gray-900 px-8 py-3 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Learn More
            </button>
          </div>
        </div>

        {/* Statistics */}
        <div className="mt-20 grid grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center space-y-2">
            <div className="text-5xl font-light text-blue-600">100%</div>
            <div className="text-gray-600 font-light">재활용 가능</div>
          </div>
          <div className="text-center space-y-2">
            <div className="text-5xl font-light text-blue-600">10x</div>
            <div className="text-gray-600 font-light">환경 영향 감소</div>
          </div>
          <div className="text-center space-y-2">
            <div className="text-5xl font-light text-blue-600">0</div>
            <div className="text-gray-600 font-light">미세플라스틱</div>
          </div>
          <div className="text-center space-y-2">
            <div className="text-5xl font-light text-blue-600">∞</div>
            <div className="text-gray-600 font-light">무한 재활용</div>
          </div>
        </div>
      </div>
    </section>
  );
}
